export default __webpack_public_path__ + "static/media/button-icon.811e06b9.svg";